import { defineStore } from 'pinia';

import InitialState from '@/InitialState';
import { apiClient } from '@/Clients/ApiClient';

import LocationsService from '@/Services/LocationsService';

const locationsService = new LocationsService(apiClient);

const locationRequests = {};

export const useProjectStore = defineStore({
    id: 'project',
    state: () => ({
        projectFollowerFacts: InitialState.projectFollowerFacts,
        projectTrackingModel: InitialState.projectTracking,
        projectSystemCategories: InitialState.projectSystemCategories,
        analyticsConfig: InitialState.analyticsConfig,
        promoItem: InitialState.promoItemState,
        featuredReward: InitialState.featuredReward,
        projectLocations: [],
    }),
    actions: {
        setProjectFollowerFacts(data) {
            const { projectID, followersCount } = data;
            this.projectFollowerFacts = {
                ...this.projectFollowerFacts,
                projectID,
                followersCount,
            };
        },
        setProjectTrackingModel(trackingModel) {
            this.projectTrackingModel = trackingModel;
        },
        setAnalyticsTrackingModel(trackingModel) {
            this.trackingModel = trackingModel;
        },
        setPromoItem(promoItem) {
            this.promoItem = promoItem;
        },
        setFeaturedReward(reward) {
            this.featuredReward = reward;
        },
        async getProjectLocations(projectID) {
            // If the locations are already loaded, return them.
            if (locationRequests[projectID]) {
                const response = await locationRequests[projectID];
                return response.data;
            }

            const requestPromise = locationsService.getProjectLocations(projectID);
            locationRequests[projectID] = requestPromise;
            const response = await requestPromise;
            this.projectLocations = response.data;

            return this.projectLocations;
        },
    },
    getters: {
        getProjectFollowerFacts: state => state.projectFollowerFacts,
        projectLocationsList: state => state.projectLocations,
    },
});